export const ASSETS = {
  hero: "/assets/hero.webp",
  parkLogo: "/assets/logo-park.webp",
  royalLogo: "/assets/logo-royal.webp",
  forestBg: "/assets/forest-bg.webp",
  forestBgMobile: "/assets/forest-bg-mobile.webp",
  heroMobile: "/assets/hero-mobile.webp",
  giraffe: "/assets/giraffe.webp",
};

export const IMG = {
  foodCollage1: "/assets/food-collage-1.webp",
  foodCollage2: "/assets/food-collage-2.webp",
  english: "/assets/english.webp",
  aboutKids: "/assets/about-kids.webp",
  gardenBg: "/assets/garden-bg.webp",
};

export const NAV = [
  { label: "Про нас", id: "pro-nas" },
  { label: "Наші садочки", id: "sadochky" },
  { label: "Розвиток", id: "rozvytok" },
  { label: "Харчування", id: "kharchuvannya" },
  { label: "Контакти", id: "kontakty" },
];

export const PORTALS = {
  park: {
    id: "park",
    name: "Park Kids Club",
    intro: "Центр міста. Паркова зона. І малеча вже в казці.",
    areaNote: "Площа садочка — 370 м², з них 200 м² — ігрова зона.",
    introImg: "/assets/park-intro.webp",
    address: "м. Дніпро, вул. Лазаря Глоби, 4",
    phone: "+38 (096) 261-22-20",
    cardImg: "/assets/arka-park.webp",
    cardPos: "50% 50%",
    glow: "rgba(16,185,129,0.45)",
    panelGradient: "linear-gradient(160deg, rgba(6,35,24,0.97) 0%, rgba(8,24,18,0.96) 60%, rgba(30,50,20,0.95) 100%)",
    border: "rgba(52,211,153,0.45)",
    particleColors: ["#ffd700", "#34d399", "#f3d079", "#a7f3d0"],
    groups: [
      {
        title: "Простір і комфорт",
        items: [
          { icon: "Car", text: "Зручна парковка", img: "/assets/park-parking.webp" },
          { icon: "Shapes", text: "Велика ігрова зона 200 м²", img: "/assets/park-gameroom.webp" },
          { icon: "Snowflake", text: "У зимку та прохолодні часи діти можуть грати в ігровій зоні", img: "/assets/park-winter.webp" },
          { icon: "Leaf", text: "Зелена паркова територія для прогулянок", img: "/assets/park-green.webp" },
          { icon: "MapPin", text: "Центр міста", img: "/assets/park-centre.webp", wide: true },
          { icon: "Wind", text: "Припливно-витяжна вентиляція" },
          { icon: "Flame", text: "Автономна система опалення" },
          { icon: "ChefHat", text: "Власна кухня та шеф-кухар" },
        ],
      },
      {
        title: "Розвиток і заняття",
        subgroups: {
          title: "Три групи: старша, середня та молодша",
          chips: ["Молодша група", "Середня група", "Старша група"],
        },
        teachNote: "Професійний підхід до кожного предмета. У нас немає «вихователів про все». Кожен предмет викладає профільний педагог.",
        items: [
          { icon: "Sparkles", text: "Пісочна арт терапія", img: "/assets/park-sand.webp" },
          { icon: "GraduationCap", text: "Дошкільна підготовка", img: "/assets/park-prep.webp" },
          { icon: "PersonStanding", text: "Хореографія", img: "/assets/park-choreo.webp" },
          { icon: "MessagesSquare", text: "Розвиток мовлення", img: "/assets/park-speech.webp" },
          { icon: "Dumbbell", text: "Кросфіт", img: "/assets/park-crossfit.webp" },
          { icon: "Music", text: "Музика" },
          { icon: "Palette", text: "Малювання" },
        ],
      },
    ],
  },
  royal: {
    id: "royal",
    name: "Royal Kids Club",
    intro: "Закрита територія, басейн і казкова атмосфера.",
    areaNote: "Площа садочка — 500 м². Чотири аудиторії для занять та ігрова зона.",
    introImg: "/assets/royal-intro.webp",
    address: "м. Дніпро, вул. Олександра Кониського, 37",
    phone: "+38 (099) 261-22-20",
    cardImg: "/assets/arka-royal.webp",
    cardPos: "50% 45%",
    glow: "rgba(59,130,246,0.45)",
    panelGradient: "linear-gradient(160deg, rgba(8,18,40,0.97) 0%, rgba(8,16,29,0.96) 60%, rgba(20,30,60,0.95) 100%)",
    border: "rgba(96,165,250,0.45)",
    particleColors: ["#ffd700", "#60a5fa", "#f3d079", "#bfdbfe"],
    groups: [
      {
        title: "Територія та безпека",
        items: [
          { icon: "Car", text: "Власна парковка", img: "/assets/royal-parking.webp" },
          { icon: "Cctv", text: "Відеоспостереження та безпека", img: "/assets/royal-cctv.webp" },
          { icon: "Fence", text: "Закрита територія", img: "/assets/royal-territory.webp" },
          { icon: "Waves", text: "Басейн", img: "/assets/royal-pool.webp" },
          { icon: "Shapes", text: "Великий дитячий майданчик", img: "/assets/royal-playground.webp" },
          { icon: "House", text: "Укриття", img: "/assets/royal-shelter.webp" },
          { icon: "Wind", text: "Припливно-витяжна вентиляція" },
          { icon: "Flame", text: "Автономна система опалення" },
        ],
      },
      {
        title: "Розвиток і заняття",
        subgroups: {
          title: "Три групи: старша, середня та молодша",
          chips: ["Молодша група", "Середня група", "Старша група"],
        },
        teachNote: "Професійний підхід до кожного предмета. У нас немає «вихователів про все». Кожен предмет викладає профільний педагог.",
        items: [
          { icon: "PersonStanding", text: "Хореографія", img: "/assets/royal-choreo.webp" },
          { icon: "GraduationCap", text: "Дошкільна підготовка", img: "/assets/svc-prep.webp" },
          { icon: "Palette", text: "Малювання", img: "/assets/royal-drawing.webp" },
          { icon: "MessagesSquare", text: "Розвиток мовлення", img: "/assets/royal-speech.webp" },
          { icon: "Dumbbell", text: "Кросфіт", img: "/assets/royal-sport.webp" },
        ],
      },
    ],
  },
};

export const DEV_CARDS = [
  { icon: "Blocks", title: "Конструктори", ratio: 1.0, img: "/assets/dev-constructor.webp" },
  { icon: "Brush", title: "Малювання", ratio: 0.75, img: "/assets/dev-drawing.webp" },
  { icon: "Hand", title: "Ліплення", ratio: 1.0, img: "/assets/dev-clay.webp" },
  { icon: "BookOpen", title: "Книги", ratio: 0.78, img: "/assets/dev-books.webp" },
  { icon: "Activity", title: "Фізична активність", ratio: 0.67, img: "/assets/dev-activity.webp" },
  { icon: "MessagesSquare", title: "Спілкування", ratio: 1.5, img: "/assets/dev-talk.webp" },
];

export const METHODS = ["Монтессорі", "Нікітіна", "Домана", "Зайцева", "Авторський підхід"];

export const ART_CARDS = [
  {
    title: "Пензель і перші мазки",
    img: "/assets/art-brush.webp",
  },
  {
    title: "Фарба на маленьких пальчиках",
    img: "/assets/art-fingers.webp",
  },
  {
    title: "Емоції, що знаходять форму",
    img: "/assets/art-form.webp",
  },
  {
    title: "Перші справжні картини",
    img: "/assets/art-paintings.webp",
  },
];

export const SERVICES = [
  { icon: "AudioLines", name: "Логопед", img: "/assets/svc-logoped.webp" },
  { icon: "Languages", name: "Індивідуальна англійська", img: "/assets/svc-english.webp" },
  { icon: "GraduationCap", name: "Дошкільна підготовка", img: "/assets/svc-prep.webp" },
  { icon: "Piano", name: "Фортепіано", img: "/assets/svc-piano.webp" },
  { icon: "Blocks", name: "LEGO", img: "/assets/svc-lego.webp" },
  { icon: "Bot", name: "Робототехніка", img: "/assets/svc-robotics.webp" },
];

export const MENU = {
  title: "Орієнтовне меню основне",
  dates: "(17.08.25 – 07.09.25)",
  days: [
    {
      day: "ПОНЕДІЛОК",
      meals: [
        { name: "Сніданок", emoji: "🍛🥐☕️", items: ["Каша рисова молочна", "Хліб + масло + сир", "Чай з лимоном"] },
        { name: "Ланч", emoji: "🍎🍇🍑", items: ["Сезонні фрукти"] },
        { name: "Обід", emoji: "🥘🥒🥖", items: ["Суп з сочевиці зі сливками та сухариками", "Каша гречана", "Кульки з курячого філе", "Овочеве асорті", "Хліб цільнозерновий", "Компот"] },
        { name: "Полудень", emoji: "🥐🥞🥨", items: ["Панкейки", "Джем/сметана", "Компот"] },
        { name: "Вечеря", emoji: "🥗🍛🥛", items: ["Каша пшоняна", "Відбивна з курячого філе", "Овочеве асорті", "Компот"] },
      ],
    },
    {
      day: "ВІВТОРОК",
      meals: [
        { name: "Сніданок", emoji: "🍛🥐☕️", items: ["Сирники", "Сметана", "Джем", "Какао"] },
        { name: "Ланч", emoji: "🍎🍇🍑", items: ["Сезонні фрукти"] },
        { name: "Обід", emoji: "🥘🥒🥖", items: ["Борщ “український”", "Макаронні вироби", "Котлета з курячого філе", "Салат овочевий", "Хліб цільнозерновий", "Узвар"] },
        { name: "Полудень", emoji: "🥐🥞🥨", items: ["Булочка", "Узвар"] },
        { name: "Вечеря", emoji: "🥗🍳🥛", items: ["Картопля варена", "Філе індички тушковане в сметані", "Овочеве асорті", "Узвар"] },
      ],
    },
    {
      day: "СЕРЕДА",
      meals: [
        { name: "Сніданок", emoji: "🍛🥐☕️", items: ["Каша гречана молочна", "Яйце варене", "Чай трав’яний"] },
        { name: "Ланч", emoji: "🍎🍇🍑", items: ["Сезонні фрукти"] },
        { name: "Обід", emoji: "🥘🥒🥖", items: ["Суп з рисом", "Каша артек", "Биточок з курячого філе", "Салат овочевий", "Хліб цільнозерновий", "Компот"] },
        { name: "Полудень", emoji: "🥐🥞🥨", items: ["Сирна паличка", "Компот"] },
        { name: "Вечеря", emoji: "🥗🍳🥛", items: ["Макаронні вироби", "Гомілка запечена", "Овочеве асорті", "Компот"] },
      ],
    },
    {
      day: "ЧЕТВЕР",
      meals: [
        { name: "Сніданок", emoji: "🍛🥐☕️", items: ["Запіканка сирна", "Сметана", "Джем", "Какао"] },
        { name: "Ланч", emoji: "🍎🍇🍑", items: ["Сезонні фрукти"] },
        { name: "Обід", emoji: "🥘🥒🥖", items: ["Суп овочевий з броколі", "Каша булгур", "Гуляш зі свинини", "Овочеве асорті", "Хліб цільнозерновий", "Узвар"] },
        { name: "Полудень", emoji: "🥐🥞🥨", items: ["Кекс з родзинками", "Узвар"] },
        { name: "Вечеря", emoji: "🥗🍳🥛", items: ["Пюре картопляне", "Котлета рибна", "Овочеве асорті", "Узвар"] },
      ],
    },
    {
      day: "П’ЯТНИЦЯ",
      meals: [
        { name: "Сніданок", emoji: "🍛🥐☕️", items: ["Каша вівсяна вісім злаків", "Хліб + масло + сир", "Чай з лимоном"] },
        { name: "Ланч", emoji: "🍎🍇🍑", items: ["Сезонні фрукти"] },
        { name: "Обід", emoji: "🥘🥒🥖", items: ["Суп з гречаною крупою", "Макаронні вироби", "Люля кебаб", "Салат овочевий", "Хліб цільнозерновий", "Компот"] },
        { name: "Полудень", emoji: "🥐🥞🥨", items: ["Гранола / печиво", "Йогурт"] },
        { name: "Вечеря", emoji: "🥗🍳🥛", items: ["Картопля варена", "Філе куряче тушковане", "Овочеве асорті", "Компот"] },
      ],
    },
  ],
};

export const CONTACTS = {
  park: {
    name: "Park Kids Club",
    address: "м. Дніпро, вул. Лазаря Глоби, 4",
    phone: "+38 (096) 261-22-20",
    phoneHref: "tel:+380962612220",
    socials: [
      { icon: "Instagram", label: "Instagram: @kidsclub_dnepr", href: "https://www.instagram.com/kidsclub_dnepr" },
      { icon: "Facebook", label: "Facebook: @kidsclub_dnepr", href: "https://www.facebook.com/kidsclub_dnepr" },
    ],
    hours: "08:00–18:00",
  },
  royal: {
    name: "Royal Kids Club",
    address: "м. Дніпро, вул. Олександра Кониського, 37",
    phone: "+38 (099) 261-22-20",
    phoneHref: "tel:+380992612220",
    socials: [
      { icon: "Instagram", label: "Instagram: @royal_kidsclub_dnepr_", href: "https://www.instagram.com/royal_kidsclub_dnepr_" },
      { icon: "Music2", label: "TikTok: @royal_kidsclub_dn", href: "https://www.tiktok.com/@royal_kidsclub_dn" },
    ],
    hours: "08:00–18:00",
  },
};

export const MAP_EMBED =
  "https://maps.google.com/maps?q=%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F%20%D0%9E%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80%D0%B0%20%D0%9A%D0%BE%D0%BD%D0%B8%D1%81%D1%8C%D0%BA%D0%BE%D0%B3%D0%BE%2C%2037%2C%20%D0%94%D0%BD%D1%96%D0%BF%D1%80%D0%BE&z=16&output=embed";

export const MAP_EMBED_PARK =
  "https://maps.google.com/maps?q=%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F%20%D0%9B%D0%B0%D0%B7%D0%B0%D1%80%D1%8F%20%D0%93%D0%BB%D0%BE%D0%B1%D0%B8%2C%204%2C%20%D0%94%D0%BD%D1%96%D0%BF%D1%80%D0%BE%2C%20%D0%94%D0%BD%D1%96%D0%BF%D1%80%D0%BE%D0%BF%D0%B5%D1%82%D1%80%D0%BE%D0%B2%D1%81%D1%8C%D0%BA%D0%B0%20%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C%2C%2049000&z=16&output=embed";

export const ASSISTANT_GREETING = "Вітаю! Я допоможу";
export const ASSISTANT_GREETING_2 = "Оберіть питання або напишіть своє";

export const ASSISTANT_FALLBACK =
  "Дякую за повідомлення! Щоб відповісти точно, ми зателефонуємо вам. Або одразу телефонуйте: Park Kids Club — +38 (096) 261-22-20, Royal Kids Club — +38 (099) 261-22-20.";

export const ASSISTANT_QA = [
  {
    q: "Чим відрізняються Park Kids Club і Royal Kids Club?",
    a: "Park Kids Club (вул. Лазаря Глоби, 4) — затишний простір у парковій зоні: зелена територія, свіже повітря та переваги природного оточення. Royal Kids Club (вул. Олександра Кониського, 37) — закрита територія, власний басейн, підвищений рівень безпеки та контрольоване середовище.",
  },
  {
    q: "Яка вартість?",
    a: "Park Kids Club — 12 000 грн/місяць (08:00–18:00). Royal Kids Club — 18 000 грн/місяць. Для військових — знижка 10%: 16 200 грн/місяць. Харчування — 500 грн/день. Адаптаційний день у Park: 1 050 грн (08:00–18:00) або 750 грн (08:00–13:00).",
  },
  {
    q: "Що входить у вартість?",
    a: "У Royal Kids Club басейн входить у вартість абонементу. В обох садочках діти щодня займаються англійською з професійними педагогами, а також розвиваються через творчість, фізичну активність та сучасні методики. Харчування оплачується окремо — 500 грн/день.",
  },
  {
    q: "Який графік роботи?",
    a: "Садочки працюють з 08:00 до 18:00. Для м’якої адаптації доступний коротший день 08:00–13:00.",
  },
  {
    q: "Як записати дитину?",
    a: "Залиште заявку у формі «Записатися на знайомство» внизу сайту — і ми зателефонуємо. Або одразу телефонуйте: Park Kids Club — +38 (096) 261-22-20, Royal Kids Club — +38 (099) 261-22-20.",
  },
  {
    q: "Які заходи безпеки?",
    a: "Закрита територія, відеоспостереження, облаштоване укриття (вентиляція, вода, освітлення, місця для відпочинку та сну), автономне опалення та власна кухня з шеф-кухарем.",
  },
  {
    q: "Як з вами зв’язатися?",
    a: "Телефони: Park Kids Club — +38 (096) 261-22-20; Royal Kids Club — +38 (099) 261-22-20. Instagram: @kidsclub_dnepr та @royal_kidsclub_dnepr_, TikTok: @royal_kidsclub_dn. Адреси: Park — м. Дніпро, вул. Лазаря Глоби, 4; Royal — м. Дніпро, вул. Олександра Кониського, 37.",
  },
];
